import React from 'react'
import { Message } from '@paypalcorp/worldready-react'
import { hasTreatmentName } from '../utils'

const secondaryHeader = [
  {
    label: <Message id="navigation.account" />,
    id: 'accountLink',
    panelId: 'account-panel',
    link: '/myaccount/settings/account',
    fptiClickData: {
      pgrp: 'main:privacyHub:home',
      page: 'main:privacyHub:home:::',
      pglk: 'main:privacyHub:home|account_tab',
      link: 'account_tab',
    },
  },
  {
    label: <Message id="navigation.security" />,
    id: 'securityLink',
    panelId: 'security-panel',
    link: '/myaccount/security',
    fptiClickData: {
      pgrp: 'main:privacyHub:home',
      page: 'main:privacyHub:home:::',
      pglk: 'main:privacyHub:home|security_tab',
      link: 'security_tab',
    },
  },
  {
    label: <Message id="navigation.privacy" />,
    id: 'privacyLink',
    panelId: 'privacy-sections-panel',
    containerClass: 'subSection-privacy-container',
    link: '#',
    fptiClickData: {
      pgrp: 'main:privacyHub:home',
      page: 'main:privacyHub:home:::',
      pglk: 'main:privacyHub:home|data&privacy_tab',
      link: 'data&privacy_tab',
    },
  },
  {
    label: <Message id="navigation.payments" />,
    id: 'paymentsLink',
    panelId: 'payments-panel',
    link: '/myaccount/settings/payments',
    fptiClickData: {
      pgrp: 'main:privacyHub:home',
      page: 'main:privacyHub:home:::',
      pglk: 'main:privacyHub:home|payments_tab',
      link: 'payments_tab',
    },
  },
  {
    label: <Message id="navigation.notification" />,
    id: 'notificationsLink',
    panelId: 'notification-panel',
    link: '/myaccount/settings/notifications',
    fptiClickData: {
      pgrp: 'main:privacyHub:home',
      page: 'main:privacyHub:home:::',
      pglk: 'main:privacyHub:home|notifications_tab',
      link: 'notifications_tab',
    },
  },
  {
    label: <Message id="navigation.seller" />,
    id: 'sellerToolsLink',
    panelId: 'sellerTools-panel',
    link: '/myaccount/profile/seller-tools',
    fptiClickData: {
      pgrp: 'main:privacyHub:home',
      page: 'main:privacyHub:home:::',
      pglk: 'main:privacyHub:home|sellerTools_tab',
      link: 'sellerTools_tab',
    },
  },
  {
    label: <Message id="navigation.statementsAndTaxes" />,
    id: 'statementsAndTaxesLink',
    panelId: 'statementsAndTaxes-panel',
    link: '/myaccount/statements',
    hasElmoTreatment: hasTreatmentName('Trmt_DocCenter_Statements_And_Taxes'),
    fptiClickData: {
      pgrp: 'main:walletweb:statementsandtaxes:Home:',
      page: 'main:walletweb:statementsandtaxes:Home::::',
      pglk: 'main:walletweb:statementsandtaxes:Home|statements&Taxes_tab',
      link: 'statements&taxes_tab',
    },
  },
]

export default secondaryHeader
